import React from 'react';
import PropTypes from 'prop-types';
import { OverflowYWrapper as Wrapper } from './styled';

export const OverflowYWrapper = ({ height, children }) => (
  <Wrapper height={height}>
    {children}
  </Wrapper>
);

OverflowYWrapper.propTypes = {
  height: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};
